import { createFileRoute } from "@tanstack/react-router";
import { codePrefixOf, getTestBlueprint } from "@brewbase/lib";
import { trpc } from "@/hooks/trpc";
import { BlueprintView } from "@/features/test-template/blueprint-view";
import { useMethodCurves } from "@/features/calibration-curves/use-method-curves";

export const Route = createFileRoute("/analytics/templates/$template_id/blueprint")({
  component: RouteComponent,
});

function RouteComponent() {
  const { template_id } = Route.useParams();
  const { data: template } = trpc.tests.testTemplates.getById.useQuery(template_id);
  const compounds = useMethodCurves(template_id).map((c) => ({
    analyte: c.analyte_code,
    name: c.analyte_name,
  }));
  const blueprint = getTestBlueprint(template?.blueprint);
  const prefix = template ? codePrefixOf(template.code) : null;
  if (!template || !blueprint || !prefix) return null;
  return (
    <div className="p-4">
      <BlueprintView
        blueprint={blueprint}
        method={{
          codePrefix: prefix,
          compounds,
          blueprintVersion: template.blueprint_version ?? blueprint.version,
        }}
      />
    </div>
  );
}
